import { useEffect } from 'react'
import Analytics, { SimpleScreenType } from '../typez'

export default function useTrackScreen({ name }: { name: SimpleScreenType }) {
  useEffect(() => {
    console.log('[use-track-screen]', { name })
    Analytics.screen(name)
  }, [name])
}
